import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from "rxjs";

import { ProgressLoaderAssurantService } from "digital-core";

@Component({
  selector: 'assurant-loader',
  templateUrl: './assurant-loader.component.html',
  styleUrls: ['./assurant-loader.component.css']
})
export class AssurantLoaderComponent implements OnInit, OnDestroy {
  show = false;
  private subscription: Subscription;
  constructor(private loaderService: ProgressLoaderAssurantService) {}
  ngOnInit() {   
    this.subscription = this.loaderService.loaderState.subscribe(value => {
      this.show = value.show;
    });
  }
  ngOnDestroy() {    
    this.subscription.unsubscribe();
  }
}
